module.exports = __webpack_public_path__ + "static/media/anchors.28cf1e35.svg";